module.exports = __webpack_public_path__ + "static/media/eunice-stahl-572017-unsplash.b6997c6d.jpg";